// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1gN-P","footer":"ModalUpdate_footer__1NFTZ"};